import { createActions, createReducer } from 'reduxsauce'

import ConsultaMetasEducacaoService from '../../servicos/ConsultaMetasEducacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaMetasEducacaoInicio: [],
    buscaConsultaMetasEducacaoSucesso: ['consultaMetasEducacao'],
    buscaConsultaMetasEducacaoErro: ['erro'],
    setSelecionadoConsultaMetasEducacaoSucesso: ['selecionado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
}

// Ação para busca completa
Creators.buscaConsultaMetasEducacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaMetasEducacaoInicio())
        let serv = new ConsultaMetasEducacaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaMetasEducacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaMetasEducacaoErro(error)))
    }
}

const buscaConsultaMetasEducacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaMetasEducacaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaMetasEducacaoSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaMetasEducacao.resultado,
        dataSincronizacaoDados: action.consultaMetasEducacao.dataSincronizacaoDados,
        carregando: false,
    }
}

const setSelecionadoConsultaMetasEducacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_METAS_EDUCACAO_INICIO]: buscaConsultaMetasEducacaoInicio,
    [Types.BUSCA_CONSULTA_METAS_EDUCACAO_ERRO]: buscaConsultaMetasEducacaoErro,
    [Types.BUSCA_CONSULTA_METAS_EDUCACAO_SUCESSO]: buscaConsultaMetasEducacaoSucesso,
    [Types.SET_SELECIONADO_CONSULTA_METAS_EDUCACAO_SUCESSO]: setSelecionadoConsultaMetasEducacaoSucesso,
})
